import React from "react";

type ITextBox = {
  label?: string;
  name: string;
  value: string;
  placeholder: string;
  onChange: (data: string, value: string) => void;
};

const TextBox: React.FC<ITextBox> = ({
  label,
  name,
  value,
  placeholder,
  onChange,
}) => {
  return (
    <div className="w-full">
      {label && <div className="w-full block mb-1 font-bold">{label}</div>}

      <div className="w-full shadow-sm">
        <textarea
          rows={4}
          name={name}
          value={value}
          placeholder={placeholder}
          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
            const { name, value } = e.target;
            onChange(name, value);
          }}
          className="w-full p-3 outline-none focus:outline-none rounded-md placeholder:text-[15px] border"
        />
      </div>
    </div>
  );
};

export default TextBox;
